import { useDarkMode } from '@/shared/hooks/useDarkMode';
import styles from './LoadingPopup.module.css';

interface LoadingPopupProps {
  show: boolean;
  isGenerating?: boolean;
}

const LoadingPopup: React.FC<LoadingPopupProps> = ({ show, isGenerating }) => {
  const { darkMode } = useDarkMode();
  if (!show) return null;

  const popupClasses = [
    styles.loadingPopup,
    darkMode ? styles.darkMode : '',
    isGenerating ? styles.generating : styles.loading
  ].join(' ');

  return (
    <div className={popupClasses}>
        <div className={styles.loader}></div>
    </div>
  );
};

export default LoadingPopup;
